export const QUERY_BY_STORE_RESET_STATE = 'QUERY_BY_STORE_RESET_STATE';
export const QUERY_BY_STORE_CURRENT_ITEM = 'QUERY_BY_STORE_CURRENT_ITEM';
 
export const QUERY_BY_STORE_REQUEST_LOADING = 'QUERY_BY_STORE_REQUEST_LOADING';
export const QUERY_BY_STORE_REQUEST_SUCCESS = 'QUERY_BY_STORE_REQUEST_SUCCESS';
export const QUERY_BY_STORE_REQUEST_FAILED = 'QUERY_BY_STORE_REQUEST_FAILED';
 
export const QUERY_BY_STORE_CURRENT_ACTION = 'QUERY_BY_STORE_CURRENT_ACTION';
export const QUERY_BY_STORE_RESET_ACTION = 'QUERY_BY_STORE_RESET_ACTION';